interface NavbarProps {
  isScrolled: boolean;
  showNavbar: boolean;
}

export default function Navbar({ isScrolled, showNavbar }: NavbarProps) {
  const navLinks = [
    { name: 'Accueil', href: '#hero' },
    { name: 'Services', href: '#tarifs' },
    { name: 'Garanties', href: '#garanties' },
    { name: 'Calculateur', href: '#calculateur' },
    { name: 'Contact', href: '#contact' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      } ${showNavbar ? 'translate-y-0' : '-translate-y-full'}`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <div className="flex items-center space-x-3">
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl transition-colors ${
                isScrolled ? 'bg-gradient-to-br from-teal-500 to-teal-600' : 'bg-white'
              }`}>
                <i className={`ri-tools-line text-2xl ${isScrolled ? 'text-white' : 'text-teal-600'}`}></i>
              </div>
              <div className="flex flex-col">
                <span className={`text-xl font-bold leading-tight transition-colors ${
                  isScrolled ? 'text-gray-900' : 'text-gray-900'
                }`}>
                  DFPRO PARTNER
                </span>
                <span className={`text-xs font-medium leading-tight transition-colors ${
                  isScrolled ? 'text-teal-600' : 'text-teal-600'
                }`}>
                  Accesleads
                </span>
              </div>
            </div>
          </div>
          <div className="hidden md:flex items-center space-x-8">
            <a
              href="#services"
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-gray-900 hover:text-teal-600'
              }`}
            >
              Nos Services
            </a>
            <a
              href="#garanties"
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-gray-900 hover:text-teal-600'
              }`}
            >
              Garanties
            </a>
            <a
              href="#diagnostic"
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-gray-900 hover:text-teal-600'
              }`}
            >
              Visio-Diagnostic
            </a>
            <a
              href="#contact"
              className="bg-teal-600 text-white px-6 py-2.5 rounded-lg text-sm font-medium hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              Demander un Devis
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}